<p>
  Thank you for completing this portion of the job application. We will now consider the information you provided in order to complete our evaluation.
</p>
